const common = require("lib/labels/_common");

// Home.group.profiles

module.exports = {
  list:{ 
    information: {
      en: "Information",
      fr: "Informations"
    }
  },
  profilesList: {
    title: {
      en: "Profiles",
      fr: "Profils"
    },
    edit: common.edit,
    remove: common.remove
  },
  profileForm: {
    stepTitle: common.profile,
    title: {
      edition: {
        en: "Profile edition",
        fr: "Edition de profil"
      },
      creation: {
        en: "Profile creation",
        fr: "Création de profil"
      }
    },
    selectAll: {
      en: "Select all",
      fr: "Tout sélectionner"
    },
    unselectAll: {
      en: "Unselect all",
      fr: "Tout désélectionner"
    },
    adminRights: {
      en: "Administrator's rights",
      fr: "Droits d'administrateur"
    },
    managerRights: {
      en: "Manager's rights",
      fr: "Droits de manager"
    },
    userRights: {
      en: "User's rights",
      fr: "Droits d'utilisateur"
    },
    name: {
      label: common.name,
      text: {
        en: "Give a profile name",
        fr: "Donnez un nom au profil"
      }
    },
    permissions: common.permissions,
    admin: {
      en: "Administrator",
      fr: "Administrateur"
    },
    manager: {
      en: "Manager",
      fr: "Manager"
    },
    user: {
      en: "User",
      fr: "Utilisateur"
    }
    ,
    gestionDesGroupes: {
      en: "Group management",
      fr: "Gestion des groupes"
    }
    ,
    gestionDesRoles: {
      en: "Role management",
      fr: "Gestion des rôles"
    }
    ,
    gestionDesMembres: {
      en: "Member management",
      fr: "Gestion des membres"
    }
    ,
    gestionDesRéglagesPersonnels: {
      en: "Personnal settings management",
      fr: "Gestions des réglages personnels"
    }
    ,
    gestionDeSonGroupePersonnel: {
      en: "Management of the personnal group",
      fr: "Gestion de son groupe personnel"
    }
    ,
    gestionDesProjets: {
      en: "Project management",
      fr: "Gestion des projets"
    }
    ,
    gestionDesApplications: {
      en: "Application management",
      fr: "Gestions des applications"
    }
    ,
    gestionDesServices: {
      en: "Service management",
      fr: "Gestion des services"
    }
    ,
    gestionDesProfiles: {
      en: "Profile management",
      fr: "Gestion des profiles"
    }
    ,
    gestionDesAPIs: {
      en: "API management",
      fr: "Gestion des APIs"
    }
    ,
    gestionDesLicences: {
      en: "Licence management",
      fr: "Gestion des licences"
    }
    ,
    gestionDesThemes: {
      en: "Theme management",
      fr: "Gestion des thèmes"
    }
    ,
    gestionDesInvitations: {
      en: "Invitation management",
      fr: "Gestion des invitations"
    }
    ,
    gestionDesParametresGenerauxUtilisateur: {
      en: "Management of general users settings",
      fr: "Gestion des paramètres généraux utilisateurs"
    }
    ,
    suppressionDesUtilisateur: {
      en: "User's deletion",
      fr: "Surppression des utilisateurs"
    }
  }
};
